import { z } from 'zod';
import i18n from '@/i18n';

export const registrationStepDateAndGenderSchema = z.object({
    // @ts-ignore
    dob: z.string().min(1, { message: i18n.t('dob_required') }).nullable(),
    // @ts-ignore
    gender: z.enum(['male', 'female'], { message: i18n.t('gender_required') }),
});

export type RegistrationStepDateAndGenderType = z.infer<typeof registrationStepDateAndGenderSchema>;
